/**
 * Global site footer — brand, quick links, and legal line.
 */
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-brand-link">
            <Logo size={26} />
            <span>PyDialog</span>
          </Link>
          <p className="footer-tagline">
            Dialog-driven learning for the South African CAPS curriculum:
            Mathematical Literacy, Mathematics, Accounting &amp; English, Grades 10–12.
          </p>
        </div>

        <div className="footer-cols">
          <div className="footer-col">
            <h4>Learn</h4>
            <Link to="/learn">Curricula</Link>
            <Link to="/how-it-works">How it works</Link>
            <Link to="/mastery">Progress &amp; mastery</Link>
          </div>
          <div className="footer-col">
            <h4>Platform</h4>
            <Link to="/for-educators">For educators</Link>
            <Link to="/caps">CAPS alignment</Link>
            <Link to="/register">Get started</Link>
          </div>
          <div className="footer-col">
            <h4>About</h4>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms &amp; Attribution</Link>
            <Link to="/contact">Contact</Link>
            {/* No GitHub link: the repository is private, so it 404'd for
                every visitor — and advertising the source of proprietary
                software invites exactly what the copyright line below
                reserves. */}
          </div>
        </div>
      </div>

      <div className="app-footer-bottom">
        <span>© {year} PyDialog. All rights reserved.</span>
        <span className="footer-madein">Aligned to the CAPS FET curriculum 🇿🇦</span>
      </div>

      <div className="app-footer-attribution">
        <p>
          Curriculum content aligned to the CAPS (Curriculum and Assessment Policy Statement)
          and NSC examination standards. Source reference: Department of Basic Education,
          Republic of South Africa. PyDialog is not affiliated with or endorsed by the DBE.
        </p>
      </div>
    </footer>
  );
}
